import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import $i18n from "@/i18n";
import axios from "axios";
const uuidv4 = require("uuid/v4");
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { Notification } from "@/modules/notifications/viewmodels/Notification";

// state
export const state = {
  channels: null,
  notifications: [],
};

export const getters = Object.assign(
  {
    notifications: (state) => {
      return state.notifications;
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/notifications",
    Notification,
    {
      // Hooks
    },
    {
      /**
       * Mark a notification as read
       * this.$store.getters['notification/api'].Custom.Read()
       */
      Read: async (notificationId) => {
        let ApiResult = null;

        try {
          ApiResult = await httpAxios.put(
            process.env.VUE_APP_BASE_URL +
              "/api/notifications/" +
              notificationId,
            { read: true }
          );
        } catch (err) {
          return;
          err.response;
        }
        return ApiResult;
      },
      /**
       * Unmark a notification as read
       * this.$store.getters['notification/api'].Custom.Unread()
       */
      Unread: async (notificationId) => {
        const api = new ApiAsyncHelper();
        let ApiResult = null;

        try {
          ApiResult = await api.$http.put(
            process.env.VUE_APP_BASE_URL +
              "/api/notifications/" +
              notificationId,
            { read: false }
          );
        } catch (err) {
          return;
          err.response;
        }
        return ApiResult;
      },
    }
  )
);

// mutations
export const mutations = {};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/notifications",
  [],
  {
    async joinChannel({ commit, dispatch }, userId) {
      if (state.channels === `user-${userId}`) return;
      await window.Echo.leave(`user-${userId}`);

      console.log(`Joining user-${userId}`);

      let result = window.Echo.join(`user-${userId}`)
        .here((users) => {
          // get online users
        })
        .joining((user) => {})
        .leaving((user) => {
          // User is leaving
        });
      if (result) {
        state.channels = `user-${userId}`;
      }
      return;
    },
  }
);
